import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Id } from 'drf-react-by-schema';

import { Model, PageBasics, SubmitSuccessTarget } from '../@types';
import { FieldValues, UseFormHandleSubmit } from 'react-hook-form';

export interface PageState extends PageBasics {
  loading: boolean;
  error: string | null;
}

const initialState: PageState = {
  usuaria: null,
  perfil: null,
  id: null,
  data: null,
  formValues: null,
  model: null,
  key: null,
  type: null,
  title: 'Babaçuais App',
  subTitle: null,
  formDisabled: true,
  handleSubmit: null,
  submitSuccessTarget: -1,
  formWizard: null,
  formWizardStep: null,
  isMobile: false,
  loading: false,
  error: null,
};

export const pageSlice = createSlice({
  name: 'mission',
  initialState,
  reducers: {
    setId: (state, { payload }: PayloadAction<Id | undefined>) => {
      state.id = payload || initialState.id;
    },
    setModel: (state, { payload }: PayloadAction<Model>) => {
      state.model = payload;
    },
    setHandleSubmit: (
      state,
      { payload }: PayloadAction<UseFormHandleSubmit<FieldValues, FieldValues> | null>
    ) => {
      state.handleSubmit = payload;
    },
    setsubmitSuccessTarget: (state, { payload }: PayloadAction<SubmitSuccessTarget>) => {
      state.submitSuccessTarget = payload;
    },
    setFormIsValid: (state, { payload }: PayloadAction<boolean | undefined>) => {
      state.formIsValid = payload;
    },
    setPage: (state, { payload }: PayloadAction<Partial<PageBasics>>) => {
      Object.assign(state, payload);
    },
  },
});

export const { setId, setModel, setPage, setFormIsValid, setHandleSubmit, setsubmitSuccessTarget } =
  pageSlice.actions;

export default pageSlice.reducer;
